import React from "react";

const AgentFooter = () => {
  return (
    <footer className="vendor-header vendor-footer border-top bg-white">
      <div className="container-fluid px-4 py-2 d-flex flex-column flex-md-row justify-content-between align-items-center">
        <div className="text-muted small">
          © 2025{" "}
          <a href="/" className="fw-semibold text-decoration-none text-dark">
            Asysta
          </a>
        </div>
        <div className="small text-muted d-none d-md-block">All rights reserved</div>
      </div>
    </footer>
  );
};

export default AgentFooter;
